module.exports = __webpack_public_path__ + "static/media/techg6.7db2bf82.svg";